import React from 'react';
import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  /** Where to go next. An empty state without a next action is a dead end. */
  actionLabel?: string;
  actionHref?: string;
  onAction?: () => void;
  compact?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  actionHref,
  onAction,
  compact = false,
}) => (
  <div className={`text-center ${compact ? 'py-6' : 'py-10'}`}>
    {Icon && <Icon className="mx-auto h-10 w-10 text-content-subtle" />}
    <h3 className="mt-3 text-body text-content font-semibold">{title}</h3>
    {description && (
      <p className="mt-1 text-body text-content-muted max-w-prose mx-auto">{description}</p>
    )}
    {actionLabel && actionHref && (
      <Link
        to={actionHref}
        className="mt-4 inline-flex items-center gap-1 text-label font-semibold text-accent hover:text-accent-hover"
      >
        {actionLabel} <span aria-hidden="true">&rarr;</span>
      </Link>
    )}
    {actionLabel && !actionHref && onAction && (
      <button
        onClick={onAction}
        className="mt-4 inline-flex items-center gap-1 text-label font-semibold text-accent hover:text-accent-hover"
      >
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
